import React, { useEffect, useRef } from "react";

import { IonContent, IonButton, IonIcon } from "@ionic/react";
import { time } from "ionicons/icons";
import moment from "moment";

import { Row, Col } from "antd";

const Order = ({ order, selected_order_id, onSelect, isReport }) => {
  const selected = order != null && selected_order_id == order.id;

  const handleSelect = () => {
    onSelect(order.id);
  };

  const getOrderTotal = () => {
    if (order == null) {
      return 0;
    }
    let total = 0;
    for (let i of order.items) {
      total += getItemTotal(i);
    }
    return total;
  };

  const getItemTotal = (item) => {
    let singleItemPrice = item.drink == null ? item.price : item.price + item.drink.price;
    return singleItemPrice * item.qty;
  };

  const getItemCount = () => {
    if (order == null) {
      return 0;
    }
    let count = 0;
    for (let i of order.items) {
      count += i.qty;
    }
    return count;
  };

  /**
   * UI Component
   */
  const PlacedItem = () => {
    return (
      <>
        <Row justify="space-between" align="middle" style={{ width: "100%" }}>
          <Col span={12} style={{ fontSize: 26, fontWeight: "bold" }}>
            #{order?.sequence}
          </Col>
          <Col span={12} style={{ textAlign: "right", fontSize: 26 }}>
            ${getOrderTotal()}
          </Col>
        </Row>

        <Row justify="end" style={{ width: "100%" }}>
          <Col style={{ fontSize: 20, fontWeight: "bold" }}>{getItemCount()}個項目</Col>
        </Row>
      </>
    );
  };

  const AcceptedItem = () => {
    return (
      <>
        <Row justify="space-between" align="middle" style={{ width: "100%" }}>
          <Col span={12} style={{ fontSize: 26, fontWeight: "bold" }}>
            #{order?.sequence}
          </Col>
          <Col span={12} style={{ textAlign: "right", fontSize: 26 }}>
            ${getOrderTotal()}
          </Col>
        </Row>

        <Row justify="end" style={{ width: "100%" }}>
          <Col style={{ fontSize: 20, fontWeight: "bold" }}>
            {order?.pickupTime != null ? (
              <Row align="middle">
                <IonIcon icon={time} />
                {moment(order.pickupTime).format("HH:mm")}
                提取
              </Row>
            ) : null}
          </Col>
        </Row>
      </>
    );
  };

  const ReportItem = () => {
    return (
      <>
        <Row justify="space-between" align="middle" style={{ width: "100%" }}>
          <Col span={12} style={{ fontSize: 26, fontWeight: "bold" }}>
            #{order?.sequence}
          </Col>
          <Col span={12} style={{ textAlign: "right", fontSize: 26 }}>
            ${getOrderTotal()}
          </Col>
        </Row>

        {/* <Row justify="end" style={{ width: "100%" }}>
          <Col  style={{ fontSize: 20, fontWeight: "bold" }}>
            {order?.pickupTime != null ? (
              <Row align="middle">
                <IonIcon icon={time} />
                {moment(order.pickupTime).format("HH:mm")}
                提取
              </Row>
            ) : null}
          </Col>
        </Row> */}
      </>
    );
  };

  return (
    <Row
      style={{
        backgroundColor: selected ? "#CB4BCD" : "#F4F4F4",
        color: selected ? "white" : "black",
        margin: "7.5px 15px",
        padding: 15,
        borderRadius: 15,
        width: "100%",
        maxWidth: "100%",
      }}
      onClick={() => {
        handleSelect();
      }}
    >
      {isReport == true ? (
        <ReportItem />
      ) : order?.status == "placed" ? (
        <PlacedItem />
      ) : order?.status == "accepted" ? (
        <AcceptedItem />
      ) : null}
    </Row>
  );
};

export default Order;
